/**
 * OrbDocTutorialsAdvancedAiGenerationSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsAdvancedAiGenerationSLDocScreen
 */

import { useOrbDocTutorialsAdvancedAiGenerationSLDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationSLDocScreenLogic';
import type { OrbDocTutorialsAdvancedAiGenerationSLDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsAdvancedAiGenerationSLDocView as OrbDocTutorialsAdvancedAiGenerationSLDocViewEntity } from '@app/shared';
import { OrbDocTutorialsAdvancedAiGenerationSLDocBodyView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationSLDocBodyView';
import { OrbDocTutorialsAdvancedAiGenerationSLDocFooterView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationSLDocFooterView';
import { OrbDocTutorialsAdvancedAiGenerationSLDocHeaderView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsAdvancedAiGenerationSLDocScreenViewProps {
  config?: Partial<OrbDocTutorialsAdvancedAiGenerationSLDocScreenConfig>;
}

export function OrbDocTutorialsAdvancedAiGenerationSLDocScreenView({ config: propsConfig }: OrbDocTutorialsAdvancedAiGenerationSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsAdvancedAiGenerationSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsAdvancedAiGenerationSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsAdvancedAiGenerationSL" trait="OrbDocTutorialsAdvancedAiGenerationSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsAdvancedAiGenerationSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsAdvancedAiGenerationSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationSLDocScreenView;
